/// <reference path="DOMAttached.js" />

class JSTabSelector extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.tabs = document.getElementById(options.Tabs);

		for (var i = 0; i < this.tabs.length; i++) {
			var button = document.getElementById(this.tabs[i].button);
			var content = document.getElementById(this.tabs[i].content);

			if (i > 0) {
				content.style.display = 'none';
				button.style.opacity = '0.5';
			}

			this.safeObserve(button, 'click', () => this.change(button, content));
		}
	}

	change(button, content) {
		for (var i = 0; i < this.tabs.length; i++) {
			document.getElementById(this.tabs[i].content).style.display = 'none';
			document.getElementById(this.tabs[i].button).style.opacity = '0.5';
		}
		content.style.display = '';
		button.style.opacity = '1';
	}
}
